import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin, Image, Tooltip } from 'antd'
import AddFitnessArticle from './add'
import EditFitnessArticle from './edit'
import DeleteFitnessArticle from './delete'
import FitnessArticleRibbon from './ribbon'
import MyIcon from '../../components/general/icon'

export default function FitnessArticle() {
  const [fitnessArticleData, setFitnessArticleData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isAddFitnessArticleVisible, setIsAddFitnessArticleVisible] = useState(false)
  const [isEditFitnessArticleVisible, setIsEditFitnessArticleVisible] = useState(false)
  const [isDeleteFitnessArticleVisible, setIsDeleteFitnessArticleVisible] = useState(false)

  const initialConditions = {
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getFitnessArticleData = () => {
    axios.post('/admin/content/fitness_article/list/get', { 
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setFitnessArticleData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'articles': response.data.articles
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getFitnessArticleData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  const editFitnessArticle = (oid) => {
    setIsEditFitnessArticleVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteFitnessArticle = (oid, title) => {
    setIsDeleteFitnessArticleVisible(true)
    setPropsData({ oid: oid, title: title})
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">健身科普</div>
            <FitnessArticleRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue} 
              isAddVisible={() => { setIsAddFitnessArticleVisible(true) }}  
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{width: '300px'}}>
                      <div className='public-main-style2-title'>标题</div>
                    </th>
                    <th>打开模式</th>
                    <th>是否置顶</th>
                    <th>发布时间</th>
                    <th style={{width: '50px'}}></th>
                  </tr>
                </thead>

                <tbody>
                  {fitnessArticleData.articles && (fitnessArticleData.articles.length > 0 ? (fitnessArticleData.articles.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editFitnessArticle(item.oid) }}>
                      <td style={{width: '300px'}}>
                        <div className='public-main-style2-tuwen'>
                          {item.cover_url && (
                          <div style={{margin: '10px 15px 10px 0'}} onClick={(event) => {event.stopPropagation()}}>
                            <Image src={item.cover_url} width={100} height={80} />
                          </div>)}
                          <span>{item.title}</span>
                        </div>
                      </td>
                      <td>{item.mode}</td>
                      <td>{item.is_top}</td>
                      <td>{item.release_time}</td>
                      <td style={{width: '50px'}}>
                        <div className='public-main-style2-operation-box'>
                          <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                            <div className='public-main-style2-operation' 
                              onClick={(event) => {event.stopPropagation(); deleteFitnessArticle(item.oid, item.title)}}>
                              <MyIcon name='huishouzhan' />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='5'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={fitnessArticleData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isAddFitnessArticleVisible && <AddFitnessArticle
          getFitnessArticleData={getFitnessArticleData} 
          isOpen={isAddFitnessArticleVisible} 
          isCancel={() => { setIsAddFitnessArticleVisible(false) }} 
        />}

        {isEditFitnessArticleVisible && <EditFitnessArticle
          data={propsData}
          getFitnessArticleData={getFitnessArticleData} 
          isOpen={isEditFitnessArticleVisible} 
          isCancel={() => { setIsEditFitnessArticleVisible(false) }} 
        />}

        {isDeleteFitnessArticleVisible && <DeleteFitnessArticle
          data={propsData}
          getFitnessArticleData={getFitnessArticleData} 
          isOpen={isDeleteFitnessArticleVisible} 
          isCancel={() => { setIsDeleteFitnessArticleVisible(false) }} 
        />}
      </Spin>
    </div>
  )
}
